import { defineStore } from 'pinia';
import sampleData from './sample.js';
export const useRegisterStore = defineStore('register', {
    state: () => {
        return {
            user: JSON.parse(sessionStorage.getItem('user') || '{"id":0, "name":"", "email":""}'),
            token: sessionStorage.getItem('token') || '',
            isAdmin: sessionStorage.getItem('isAdmin') ? 1 : 0,
            formData: sessionStorage.getItem('form') ? JSON.parse(sessionStorage.getItem('form')) : (import.meta.env.DEV ? sampleData : {
                "tipoPessoa": "Física",
                "possuiLogomarca": "Não",
                "possuiDominio": "Não",
            })
        }
    },
    getters: {
        getFormData: (state) => state.formData,
        getToken: (state) => state.token,
        getIsAdmin: (state) => state.isAdmin,
        getUser: (state) => JSON.parse(state.user)
    },
    actions: {
        setFormData(data) {
            console.log('setFormData chamado com:', data);
            for(const key in data) {
                this.$state.formData[key] = data[key];
            }
            sessionStorage.setItem('form', JSON.stringify(this.$state.formData));
        },
        setToken(token) {
            this.token = token;
            sessionStorage.setItem('token', token);
        },
        setIsAdmin(isAdmin) {
            this.isAdmin = isAdmin;
            sessionStorage.setItem('isAdmin', isAdmin);
        },
        setUser(user) {
            this.user = user;
            sessionStorage.setItem('user', JSON.stringify(user));
        },
        logout() {
            this.user = {};
            this.token = '';
            this.isAdmin = false;
            sessionStorage.removeItem('user');
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('isAdmin');
            location.href = '/';
        }
    }
});